import { Card } from 'antd';
import styled from 'styled-components';

const Cards = styled(Card)`
  min-width: 190px;
  width: 100%;
  margin: auto;
  .ant-card-body {
    padding: 8px 12px;
  }
`;

const CountCard = styled.h2`
  font-weight: bold;
  margin: 0;
  font-size: 20px;
  line-height: 1.2;
`;

const ContentUser = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  p {
    font-family: sans-serif;
  }
  .iconCancel {
    color: #5c62ed;
    background-color: #5c62ed10;
    border-radius: 4px;
    width: 33px;
    height: 33px;
    padding: 4px;
  }
  .iconCheck {
    color: #fa8c0d;
    background-color: #fa8c0d10;
    border-radius: 4px;
    width: 33px;
    height: 33px;
    padding: 4px;
  }
  .iconCreate {
    color: #f63078;
    background-color: #f6307810;
    border-radius: 4px;
    width: 33px;
    height: 33px;
    padding: 4px;
  }
  .iconConfirmed {
    color: #35cd9e;
    background-color: #35cd9e10;
    border-radius: 4px;
    width: 33px;
    height: 33px;
    padding: 4px;
  }
`;

const ContentServiceState = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex-wrap: wrap;
  p {
    font-family: sans-serif;
  }

  .icon {
    color: ${(props) => `${props.variant}`};
    background-color: ${(props) => `${props.variant}30`};
    border-radius: 4px;
    width: 33px;
    height: 33px;
    padding: 4px;
  }
`;

const Title = styled.p`
  display: flex;
  margin: 2px 0 0 41px;
  color: grey;
  font-size: 12px;
  line-height: 1.2;
`;

export { ContentUser, Title, Cards, CountCard, ContentServiceState };
